<template>
    <app-layout>
        <template #header>
            <FarmTitle :farm="farm">
                Produkte
            </FarmTitle>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="mb-4">
                    <label for="search" class="block text-sm font-medium text-gray-700">Suche</label>
                    <div class="mt-1">
                        <input type="text" name="search" id="search" v-model="search" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="Produktsuche">
                    </div>
                </div>
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <div class="flex flex-col">
                        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                    <table class="min-w-full divide-y divide-gray-200">
                                        <thead class="bg-gray-50">
                                        <tr>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Name
                                            </th>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Artikelnummer
                                            </th>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Art
                                            </th>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Bruttopreis
                                            </th>
                                            <th scope="col" class="relative px-6 py-3">
                                                <span class="sr-only">Bearbeiten</span>
                                                <button @click="addProduct = true" type="button" class="inline-flex items-center p-2 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                                    <PlusIcon class="h-5 w-5" aria-hidden="true" />
                                                </button>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <!-- Odd row -->
                                        <template v-for="(product, i) in products.filter(item => { for(x of ['name']) {if(item[x].toLowerCase().includes(search.toLowerCase())) return true} return false})">
                                            <tr :class="i%2 == 0 ? 'bg-white' : 'bg-gray-50'">
                                                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                    {{ product.name }}
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                    {{ product.item_number }}
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                    <span v-if="product.type == 'extra'" class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-green-100 text-green-800">
                                                        Einzelpreis
                                                    </span>
                                                    <span v-if="product.type == 'stable_price'" class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800">
                                                        Stallmiete
                                                    </span>
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                    <template v-if="product.type == 'extra'">
                                                        {{ product.price_string }}
                                                        <span v-if="!product.price_string" class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-red-100 text-red-800">
                                                            <ExclamationIcon class="w-4 h-4 text-red-400 mr-3" />
                                                            Kein Preis vorhanden
                                                        </span>
                                                    </template>
                                                    <template v-else>
                                                        <span class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-gray-100 text-gray-800">
                                                            Individueller Preis
                                                        </span>
                                                    </template>

                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                    <button v-if="product.type == 'extra'" @click="product_edit = product" class="text-indigo-600 hover:text-indigo-900 ml-4 cursor-pointer">Preise einsehen/festlegen</button>
                                                    <inertia-link :href="route('farm.stables', farm)" v-else class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800">
                                                        Preise unter "Ställe" festlegen
                                                    </inertia-link>
                                                </td>
                                            </tr>
                                        </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <jet-dialog-modal :show="product_edit">
            <template #title>
                Preishistorie {{ product_edit.name }}
            </template>

            <template #content>
                <div class="flex flex-col">
                    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                <table class="min-w-full divide-y divide-gray-200">
                                    <thead class="bg-gray-50">
                                    <tr>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Name
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Datum
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Preis
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Ust
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, itemIdx) in product_edit.price_history" :class="itemIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'">
                                        <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                            {{ item.name }}
                                            <span class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium ml-4" :class="new Date(item.in_effect_from).setHours(0,0,0,0) > new Date().setHours(0,0,0,0) ? 'bg-green-100 text-green-800' : item.in_effect_till ? new Date(item.in_effect_till) >= new Date() ? 'bg-yellow-100 text-yellow-800' : 'bg-gray-100 text-gray-800' : 'bg-indigo-100 text-indigo-800' ">
                                                {{ new Date(item.in_effect_from).setHours(0,0,0,0) > new Date().setHours(0,0,0,0) ? 'Zukünftiger Preis' : item.in_effect_till ? new Date(item.in_effect_till).setHours(0,0,0,0) >= new Date().setHours(0,0,0,0) ? 'Aktueller Preis (befristet)' : 'Alter Preis' : 'Aktueller Preis'  }}
                                            </span>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            {{ new Intl.DateTimeFormat('de-DE').format(new Date(item.in_effect_from)) }}
                                            <template v-if="item.in_effect_till">
                                                -
                                                {{ new Intl.DateTimeFormat('de-DE').format(new Date(item.in_effect_till)) }}
                                            </template>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            {{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 4 }).format(item.value) }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            {{ item.vat }} %
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <h1 class="mt-5 text-base font-semibold text-indigo-600 tracking-wide uppercase">Preis ändern</h1>
                <div class="mt-5">
                    <label for="email" class="block text-sm font-medium text-gray-700">Datum des Inkrafttretens</label>
                    <div class="mt-1 relative rounded-md shadow-sm">
                        <input type="date" name="email" id="email" class="block w-full sm:text-sm rounded-md"  :class="new Date(dateForm.date) < new Date(farm.last_export) ? 'border-red-300 text-red-900 placeholder-red-300 focus:outline-none focus:ring-red-500 focus:border-red-500 pr-10' : 'focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 text-gray-700' " v-model="dateForm.date" />
                        <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" v-if="new Date(dateForm.date) < new Date(farm.last_export)">
                            <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
                        </div>
                    </div>
                    <p class="mt-2 text-sm text-red-600" v-if="new Date(dateForm.date) < new Date(farm.last_export)">Das inkrafttreten des Preises kann nicht vor dem letzten Export ({{ new Intl.DateTimeFormat().format(new Date(farm.last_export)) }}) liegen. Sollte dies ein Fehler <strong>und der Export nocht nicht verarbeitet worden</strong> sein, so können Sie unseren Support kontaktieren.<br><u><strong>Sie können diese Meldung ignorieren. Als Datum des Inkrafttrens wird dann der erste Tag nach dem letzten Export, also der {{ new Intl.DateTimeFormat().format(new Date(new Date(farm.last_export).setDate(new Date(farm.last_export).getDate() + 1))) }} gewählt.</strong></u></p>
                </div>
                <div class="md:grid-cols-12 md:grid md:gap-4 mt-3">
                    <div class="md:col-span-8">
                        <label for="price" class="block text-sm font-medium text-gray-700" >
                            Preis
                        </label>
                        <div class="mt-1">
                            <input type="number"  id="price" step="0.01" v-model="dateForm.price" autocomplete="date" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                            <jet-input-error :message="dateForm.errors.price" />
                        </div>
                    </div>
                    <div class="md:col-span-4">
                        <label for="vat" class="block text-sm font-medium text-gray-700" >
                            Umsatzsteuer
                        </label>
                        <div class="mt-1">
                            <input type="number" id="vat" v-model="dateForm.vat" autocomplete="date" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                            <jet-input-error :message="dateForm.errors.vat" />
                        </div>
                    </div>
                    <div class="flex justify-end md:col-span-12">
                        <button @click="dateForm.post(route('product.prices.store', product_edit), {
                        onSuccess: () => {
                            product_edit = false
                        }
                    })" class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                            Preis hinzufügen
                        </button>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="flex justify-end">
                    <button @click="product_edit = false" type="button" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        Schließen
                    </button>
                </div>
            </template>
        </jet-dialog-modal>
        <jet-dialog-modal :show="addProduct">
        <template #title>
            Produkt
        </template>

        <template #content>
            <div class="mt-6 md:grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                <div class="col-span-6">
                    <label for="name" class="block text-sm font-medium text-gray-700" >
                        Name
                    </label>
                    <div class="mt-1">
                        <input type="text" name="first_name" id="name" v-model="product.name" autocomplete="name" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                        <jet-input-error :message="product.errors.name" />
                    </div>
                </div>
                <div class="col-span-6">
                    <label for="email" class="block text-sm font-medium text-gray-700" >
                        Artikelbezeichnung
                    </label>
                    <div class="mt-1">
                        <input type="text" name="first_name" v-model="product.item_number" autocomplete="email" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                        <jet-input-error :message="product.errors.item_number" />
                    </div>
                </div>
            </div>
            <fieldset class="mt-5">
                <legend class="sr-only">
                    Artikeltyp
                </legend>
                <div class="bg-white rounded-md -space-y-px">
                    <!-- Checked: "bg-indigo-50 border-indigo-200 z-10", Not Checked: "border-gray-200" -->
                    <label @click="product.type = article.internal" class="relative border p-4 flex cursor-pointer" :class="i + 1 == article_type.length ? 'rounded-md' : 'rounded-tl-md rounded-tr-md', product.type == article.internal ? 'bg-indigo-50 border-indigo-200 z-10' : 'border-gray-200'" v-for="(article, i) in article_type">
                        <input type="radio" name="privacy_setting" :checked="product.type == article.internal" class="h-4 w-4 mt-0.5 cursor-pointer text-indigo-600 border-gray-300 focus:ring-indigo-500" aria-labelledby="privacy-setting-0-label" aria-describedby="privacy-setting-0-description">
                        <div class="ml-3 flex flex-col">
                            <!-- Checked: "text-indigo-900", Not Checked: "text-gray-900" -->
                            <span :class="product.type == article.internal ? 'text-indigo-900' : 'text-gray-900'" id="privacy-setting-0-label" class="block text-sm font-medium">
                              {{ article.name }}
                            </span>
                            <!-- Checked: "text-indigo-700", Not Checked: "text-gray-500" -->
                            <span :class="product.type == article.internal ? 'text-indigo-700' : 'text-gray-500'" id="privacy-setting-0-description" class="block text-sm">
                              {{ article.desc }}
                            </span>
                        </div>
                    </label>
                </div>
            </fieldset>
        </template>
        <template #footer>
            <div class="flex justify-end">
                <button @click="addProduct = false" type="button" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    Abbrechen
                </button>
                <button @click="product.post(route('farm.products.store', {farm: farm}), {
                        onSuccess: () => {
                            addProduct = false;
                        }
                    })" class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    Produkt erstellen
                </button>
            </div>
        </template>
        </jet-dialog-modal>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import HorseEdit from "@/Modules/HorseEdit";
import Button from "@/Jetstream/Button";
import FarmTitle from "@/Layouts/FarmTitle";
import { ExclamationIcon, InformationCircleIcon, PlusIcon } from "@heroicons/vue/solid";
import JetDialogModal from "@/Jetstream/DialogModal";
import JetInputError from "@/Jetstream/InputError";

export default {
    name: "Farm",
    components: {FarmTitle, Button, HorseEdit, AppLayout, ExclamationIcon, InformationCircleIcon, PlusIcon, JetInputError, JetDialogModal },
    props: ['farm', 'products'],
    data: function () {
        return {
            search: '',
            product_edit: false,
            dateForm: this.$inertia.form({
                date: new Date().toISOString().split('T')[0],
                price: 0,
                vat: 19,
                product: null
            }),
            addProduct: false,
            product: this.$inertia.form({
                name: '',
                item_number: '',
                type: 'extra'
            }),
            article_type: [
                {
                    name: 'Einzelner Posten',
                    desc: 'Als einzelnen Posten, welcher einem Pferd hinzugeordnet werden kann, hinzufügen.',
                    internal: 'extra',
                },
                {
                    name: 'Stallmiete',
                    desc: 'Als Posten, welcher einem Stall zugeordnet werden kann, hinzufügen..',
                    internal: 'stable_price',
                }
            ]
        }
    }
}
</script>

<style scoped>

</style>
